import { Component, OnInit } from '@angular/core';
import { MasterService,ClassroomService } from '../../services/index';
import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons, NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { AppGlobals } from '../../shared/app.global';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-candidate',
  templateUrl: './candidate.component.html',
  styleUrls: ['./candidate.component.scss'],
  providers:[MasterService,ClassroomService]
})
export class VtcandidateComponent implements OnInit {

  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
    sections:any=[];
    classes:any=[];
    arrstudent:any=[];
    fmodel:any={clid:'0',secid:'0',subid:'0',prid:'0'};
    arrrepdata:any=[];
    arrper:any=[];
    arrashead:any=[];
    arrcourse:any=[];
    arrpost:any=[];
    arrastype:any=[];
    arrastype1:any=[];
    dropdownList = [];
    selectedItems = [];
    oprtype:any='';
    objcan:any={};
    objfilt:any={boothid:'0',postid:'0'};
    tabledata: any = {};
    rcremarks='';
    fileToUpload: File = null;
    arrcat:any=[];
    dropdownSettings:IDropdownSettings = {singleSelection: false,
      idField: 'stuid',
      textField: 'stunm',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 0,
      allowSearchFilter: true};

fData: FormData = new FormData;
  arrsel:boolean=false;
  btntype: any;
  arrbooth: any;
  sertxt: any;
  arrrepdata1: any;
    constructor(private http: HttpClient,private aservice:ClassroomService, private mservice: MasterService,private modalService: NgbModal,private _global: AppGlobals) { }
  
    ngOnInit(): void {
     
      // this.mascourse();
     this.getbooths();
this.getposts();
     
      //this.subjects();
      this.fmodel.attdt=this.mservice.getdatetoday();
      this.fmodel.frtime=this.mservice.getcurenttime();
      this.fmodel.totime=this.mservice.getcurenttime();
      
     
    }
  
    checknumber(ele) {
      if (ele.score < 0 || ele.score==null  )
      {

        ele.score = 0.00;
      }
      else if (ele.score > ele.maxsc) {
        alert('Marks should be less than or equal to maxscore');
        ele.score = ele.accscore1;
  
        console.log("accscore1", ele.accscore1 + " & " + ele.accscore);
      }
      // else {
      //   ele.accscore = parseFloat(ele.accscore).toFixed(0);
      // }
    }
    masclass() {
      // this.mservice.classmasterrolewise(0,this.fmodel.crid,0,'class')
       this.mservice.masclass()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.classes = resultArray;
              this.fmodel.clid=resultArray[0].clid;
              this.massection();
            //  this.masperiod();
              
             
          },
          error => console.log("Error :: " + error)
          )
    }

    onsearch()
    {
       this.arrrepdata=this.arrrepdata1.filter(item => item.stunm.toLowerCase().includes(this.sertxt.toLowerCase()));
    }

     printcertificate(){
  debugger
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');

   var url=this.mservice.callurl+"/fpdf181/pdfreports/votecandidate.php?clcd="+clcd+"&aycd="+aycd+"&vctid="+this.objfilt.vctid+"&postid="+this.objfilt.postid+"&boothid="+this.objfilt.boothid;

   window.open(url,'');
  
 }

    getcandidate() {
      this.aservice.getcanlist(this.objfilt)
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);

               
              this.arrrepdata = resultArray;
              this.arrrepdata.map(function(entry) {
            entry.selected = false;
            // entry.wavedfamt=0;
            // entry.wavedramt=0
            // entry.recamt=0
            return entry;
        });

         this.arrrepdata1 = resultArray;
         this.arrrepdata1.map(function(entry) {
            entry.selected = false;
            // entry.wavedfamt=0;
            // entry.wavedramt=0
            // entry.recamt=0
            return entry;
        });
             
              
             
          },
          error => console.log("Error :: " + error)
          )
          console.log('allcirculated1', this.arrrepdata);
    }

    massection() {
      // this.mservice.sectionsrolewise(0,this.fmodel.crid,this.fmodel.clid,'section')
      this.mservice.massection()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.sections = resultArray;
              this.fmodel.secid=resultArray[0].scid;
             // this.masasshead();
             this.getvotecategory();
          },
          error => console.log("Error :: " + error)
          )
    }


    delcan(id) {
      debugger
     if(confirm("Are you sure you want to remove?"))
     {
      this.aservice.delcan(id)
           .subscribe(resultArray => {
              console.log('ret-loop', resultArray);
    //var cbclid=this.fmodel1,cbclid
              alert(resultArray.message);
              if(resultArray.status=='Success')
              {
                
             
              this.selectedItems=[];
        
                this.getcandidate();
                this.getstudentsdata();
              
              }
          }, error =>
              alert('error in connection')
          );
    }
    }
    
 

      onclasschange()
      {
        this.massection();
this.getcandidate();
      }
  
  


      Savercremarks(obj) {
        var objpost={asid:obj.assid,stuid:obj.stuid,rcremarks:this.rcremarks};
        this.aservice.Savercremarks(objpost)
          .subscribe(result => {
            console.log('ret-loop', result);
            alert(result.message);
            //this.Getsel_sp_masassmodel();
          }, error =>
            alert('error in connection')
          );
      }
  
    
      mascourse() {
        this.mservice.mascourse()
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arrcourse = resultArray;
                this.fmodel.crid=resultArray[0].crid;
                this.masclass();
                //this.fmodel1.crid=resultArray[0].crid;
            },
            error => console.log("Error :: " + error)
            )
      }

      getbooths() {
        this.mservice.masbooth()
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arrbooth = resultArray;
               
                this.fmodel.boothid=resultArray[0].boothid;
            },
            error => console.log("Error :: " + error)
            )
      }

      getposts() {
        this.mservice.masposts()
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arrpost = resultArray;
               
                this.fmodel.postid=resultArray[0].postid;
                this.getvotecategory();
            },
            error => console.log("Error :: " + error)
            )
      }

      
getvotecategory() {
        this.aservice.getvotecategory()
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arrcat = resultArray;
                this.fmodel.vctid=resultArray[0].vctid;
                this.objfilt.vctid=resultArray[0].vctid;
                this.getstudentsdata();
                 this.getcandidate();
                // this.masclass();
                //this.fmodel1.crid=resultArray[0].crid;
            },
            error => console.log("Error :: " + error)
            )
      }
     
      getstudentsdata() {
        this.aservice.getstudents_bytype(this.fmodel.clid,this.fmodel.secid,this.fmodel.crid,"voting",this.fmodel.vctid)
            .subscribe(
            resultArray => {
                console.log('bloodgp', resultArray);

                this.arrstudent=resultArray;
                // this.arrstudent =  resultArray.filter(item => this.arrrepdata.find(y => y.stuid !== item.stuid));
                //                     //  jsonArray.filter((item) => filterArray.includes(item.id));
                console.log('bloodgp', this.arrstudent);
            },
            error => console.log("Error :: " + error)
            )
      }

      opensymbol(content,obj)
{
// this.getaccno_series();
this.objcan=obj;
this.modalOptions = {
  backdrop:'static',
  backdropClass:'customBackdrop',
  size:'md'
 }
this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        // this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}



 updatecanbooths(boothid) {
  debugger
 
   var selitems= this.arrrepdata.filter(function(arr)
    {

      return arr.selected==true;
    })
  this.aservice.updatecanbooths(this.fmodel,selitems,boothid)
       .subscribe(resultArray => {
          console.log('ret-loop', resultArray);
//var cbclid=this.fmodel1,cbclid
          alert(resultArray.message);
          if(resultArray.status=='Success')
          {
            
         
         
            let localmodref=this.modalRef;
            localmodref.close();
          selitems=[];
          this.getcandidate();
          // this.getcandidate("selstu");
          // this.getstudentsdata("voterstu");
          }
      }, error =>
          alert('error in connection')
      );
}

openedit(content,obj)
{
// this.getaccno_series();
// this.getposts();
// this.getbooths();
// this.objcan=obj;
this.modalOptions = {
  backdrop:'static',
  backdropClass:'customBackdrop',
  size:'md'
 }
this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        // this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}

      upload(files: FileList) {
        debugger;
        this.fileToUpload = files.item(0);
      
       
      }
      
      
     
      fileupload()
      {
      debugger
      
      console.log('file data',JSON.stringify(this.fileToUpload));
      
      this.aservice.uploadsymbol(this.fileToUpload,this.objcan)
      .subscribe(fresult => {
         // console.log('ret',JSON.stringify(fresult));
          alert (fresult.message);
          if(fresult.status=='Success')
      {
      let localmodref=this.modalRef;
      localmodref.close();
      this.getcandidate();
      this.fileToUpload=null;
      // this.dcid=0;
      // this.disuploadbtn=true;
      // this.photo=fresult.updfilepath;
      
      }
          
      }, error => 
      alert('error in connection')
      
      );
      
      
      
      }

      openinfo(content)
 {
  
 
   this.modalOptions = {
     backdrop:'static',
     backdropClass:'customBackdrop',
     size:'lg'
    }
   this.modalRef=this.modalService.open(content,this.modalOptions);
   
   this.modalRef.result.then((result) => {
  
        // this.Asmtdetls(asid);
         //this.closeResult = `Closed with: ${result}`;
     }, (reason) => {
         //this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     });
 }
 

 savecbmclassd() {
  debugger
 
  this.aservice.savecandidate(this.fmodel,this.selectedItems)
       .subscribe(resultArray => {
          console.log('ret-loop', resultArray);
//var cbclid=this.fmodel1,cbclid
          alert(resultArray.message);
          if(resultArray.status=='Success')
          {
            
         
          this.selectedItems=[];
          this.getcandidate();
          this.getstudentsdata();
          }
      }, error =>
          alert('error in connection')
      );
}
        
updcanpost() {
  debugger
 
  this.aservice.updcandidatepost(this.objcan)
       .subscribe(resultArray => {
          console.log('ret-loop', resultArray);
//var cbclid=this.fmodel1,cbclid
          alert(resultArray.message);
          if(resultArray.status=='Success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
         
        
          this.getcandidate();
         
          }
      }, error =>
          alert('error in connection')
      );
}



 updatepost(boothid) {
  debugger
 
   var selitems= this.arrrepdata.filter(function(arr)
    {

      return arr.selected==true;
    })
  this.aservice.updatepost(this.fmodel,selitems,boothid)
       .subscribe(resultArray => {
          console.log('ret-loop', resultArray);
//var cbclid=this.fmodel1,cbclid
          alert(resultArray.message);
          if(resultArray.status=='Success')
          {
            
         
         
            let localmodref=this.modalRef;
            localmodref.close();
          selitems=[];
          this.getcandidate();
          // this.getcandidate("selstu");
          // this.getstudentsdata("voterstu");
          }
      }, error =>
          alert('error in connection')
      );
}


  renselectedAll: any=false;
renselectAll() {
  debugger
    for (var i = 0; i < this.arrrepdata.length; i++) {
      this.arrrepdata[i].selected = this.renselectedAll;
    }
     this.arrsel= this.arrrepdata.some(item => item.selected);
  }
  rencheckIfAllSelected() {
    this.renselectedAll = this.arrrepdata.every(function(item:any) {
        return item.selected == true;
      });

   this.arrsel= this.arrrepdata.some(item => item.selected);
  //  console.log('arrsel',this.arrsel.length);
  }

  
openbooth(content,tag)
{
// this.getaccno_series();
// this.getbooths();
this.btntype=tag;
// this.objcan=obj;
this.modalOptions = {
  backdrop:'static',
  backdropClass:'customBackdrop',
  size:'md'
 }
this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        // this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}


  
opencan(content,tag)
{
// this.getaccno_series();
// this.getbooths();
this.mascourse();
this.btntype=tag;
// this.objcan=obj;
this.modalOptions = {
  backdrop:'static',
  backdropClass:'customBackdrop',
  size:'lg'
 }
this.modalRef=this.modalService.open(content,this.modalOptions);
  
  this.modalRef.result.then((result) => {
 
       // this.Asmtdetls(asid);
        // this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
        // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
}

      
  }
